// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"CardsAppA_TheComp__1iB7J"};